import React, { useEffect } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import { useAuth } from '../providers/AuthContext'
import { LoadingPage } from '../components/PageLoading'
export const WorklistPage = ({ instanceData }) => {

  const title = instanceData?.title || 'Purview Image'
  const { isCheckingAuth } = useAuth()
  useEffect(() => {
    document.title = title
  }, [title])

  if (isCheckingAuth) {
    return <><LoadingPage /></>
  }

  return <div style={{height: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column'}}>
    <HeaderComponent />
    <iframe src="/wl/" width={'100%'}  title={title} style={{border: '0px', margin: '0px', padding: '0px', height: '100%'}}></iframe>
  </div>
}